import { render } from "./solidadd.vue?vue&type=template&id=5da61023&scoped=true"
import script from "./solidadd.vue?vue&type=script&lang=js"
export * from "./solidadd.vue?vue&type=script&lang=js"

import "./solidadd.vue?vue&type=style&index=0&id=5da61023&scoped=true&lang=stylus&rel=stylesheet%2Fstylus"

import exportComponent from "/opt/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5da61023"]])

export default __exports__